module.exports = __webpack_public_path__ + "static/img/searchbar-icon.4332483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/searchbar-icon.png
// module id = 65t5
// module chunks = 1